import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import {
  FiGrid,
  FiUsers,
  FiTruck,
  FiTrendingUp,
  FiCreditCard,
  FiDollarSign,
  FiLogOut,
  FiMenu,
  FiX,
  FiBriefcase,
} from 'react-icons/fi';

function AdminLayout() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const navItems = [
    { to: '/admin', icon: FiGrid, label: 'Dashboard', end: true },
    { to: '/admin/farmers', icon: FiUsers, label: 'Farmers', end: false },
    { to: '/admin/suppliers', icon: FiTruck, label: 'Suppliers', end: false },
    { to: '/admin/risk-scores', icon: FiTrendingUp, label: 'Risk Scores', end: false },
    { to: '/admin/vouchers', icon: FiCreditCard, label: 'Vouchers', end: false },
    { to: '/admin/financing', icon: FiDollarSign, label: 'Financing', end: false },
    { to: '/admin/investors', icon: FiBriefcase, label: 'Investors', end: false },
  ];

  return (
    <div className="admin-layout">
      <aside className={`admin-sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="admin-sidebar-header">
          <span className="admin-logo">AGRO-INVEST</span>
          <button
            className="admin-sidebar-close"
            onClick={() => setSidebarOpen(false)}
            aria-label="Close menu"
          >
            <FiX />
          </button>
        </div>
        <nav className="admin-nav">
          {navItems.map(({ to, icon: Icon, label, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `admin-nav-item ${isActive ? 'active' : ''}`
              }
              onClick={() => setSidebarOpen(false)}
            >
              <Icon className="admin-nav-icon" />
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="admin-sidebar-footer">
          <button className="admin-logout-btn" onClick={handleLogout}>
            <FiLogOut />
            <span>Logout</span>
          </button>
        </div>
      </aside>
      <div className="admin-main">
        <header className="admin-topbar">
          <button
            className="admin-menu-toggle"
            onClick={() => setSidebarOpen(true)}
            aria-label="Open menu"
          >
            <FiMenu />
          </button>
          <div className="admin-topbar-spacer" />
        </header>
        <main className="admin-content">
          <Outlet />
        </main>
      </div>
      {sidebarOpen && (
        <div
          className="admin-overlay"
          onClick={() => setSidebarOpen(false)}
          aria-hidden="true"
        />
      )}
    </div>
  );
}

export default AdminLayout;
